import React, { useMemo } from 'react';
import { useListDedicatedIps } from '../../../query/dedicatedIp';
import { Table } from '../../../components/ui';
import moment from 'moment/moment';
import DeleteDedicatedIpButton from './DeleteDedicatedIpButton';

export default function DedicatedIpTable() {
  const { data, isLoading } = useListDedicatedIps();
  const columns = useMemo(() => {
    return [
      {
        title: 'Id',
        dataIndex: 'id',
        key: 'id',
        width: 80,
      },
      {
        title: 'IP Address',
        dataIndex: 'ip',
        key: 'ip',
      },
      {
        title: 'Service',
        dataIndex: 'esp',
        key: 'esp',
      },
      {
        title: 'Risk Score (lower is better)',
        dataIndex: 'score',
        key: 'score',
        width: 230,
        render: s => <p style={{ textAlign: 'center' }}>{s}</p>,
      },
      {
        title: 'Created At',
        dataIndex: 'created_at',
        render: d => moment(d).format('YYYY-MM-DD HH:mm:ss'),
        width: 200,
      },
      {
        title: 'Actions',
        dataIndex: 'action',
        render: (d, { id }) => <DeleteDedicatedIpButton id={id} />,
        width: 200,
      },
    ];
  }, []);
  return (
    <Table columns={columns} dataSource={data || []} loading={isLoading} />
  );
}
